import {MatrixItem} from './matrix.item';

export class Matrix {
  ID: string;
  ITEMS: MatrixItem[];
  FIELDS: any = {};

  SHOW_SECTION_PRODUCTS: boolean;
  SHOW_SECTION_CLIENTS: boolean;
  SHOW_SECTION_COMPETITION: boolean;
  SHOW_SECTION_FINANCIALS: boolean;

  constructor(value: any = {}) {
    Object.assign(this, value);

    if (value.ITEMS) {
      this.ITEMS = MatrixItem.parseArray(value.ITEMS);
    }
  }

  static parseArray(json: any[]): Matrix[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new Matrix(j));
        }
      }
    }

    return arr;
  }
}
